import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function AdminLogout() {
    const navigate = useNavigate();

    useEffect(() => {
        localStorage.removeItem('access_token');
        // alert('ログアウトしました');
        navigate('/login');
    }, [navigate]);

    return null;
}

export default AdminLogout;
